import Repository from './Repository'

export default {
  /*
  get(offset, perPage, onlyOwn) {
    return Repository('getReportArticles', {
      offset: offset,
      perPage: perPage,
      onlyOwn: onlyOwn,
    })
  },
  */
  getIndex() {
    return Repository('getReportArticleTop')
  },
  getNew(offset, perPage) {
    // Servercodeの仕様で10件固定
    return Repository('getNewArrivalReportArticles', {
      offset: offset,
      perPage: perPage,
    })
  },
  getTag(tagIds, sortBy, offset, perPage) {
    return Repository('getReportArticlesByTag', {
      tagIds: tagIds,
      sortBy: sortBy,
      offset: offset,
      perPage: perPage,
    })
  },
  getRanking() {
    return Repository('getReportArticleRanking')
  },
  getPopularTags() {
    return Repository('getReportArticlePopularTags')
  },
}
